import { useRoute } from 'vue-router/composables'
import { asyncTrack } from '@/track'

export function useTechHttpCost() {
  const staticResource = ['css', 'script', 'img', 'link', 'other']
  const regex = /https?:\/\/(static\.rocnovel\.com)(?:\/.*?\/)([^\/?]+\.txt)/i
  const route = useRoute()

  function performanceObserver() {
    if (window.PerformanceObserver) {
      const observer = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry: any) => {
          // console.log('entry', entry)
          if (staticResource.includes(entry.initiatorType) || regex.test(entry.name))
            resourceTiming(entry)
        })
      })

      // 监听所有资源类型
      observer.observe({ type: 'resource', buffered: true })
    }
  }

  function resourceTiming(entry: any) {
    asyncTrack('tech_http_cost', {
      http_url: entry.name,
      response_code: entry.responseStatus,
      request_type: 'static',
      cost_ms: entry.duration,
      page_title: route.meta?.title,
    })
  }

  return {
    performanceObserver,
  }
}
